import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../BasePanelPage";
import {Messages} from "../../../../Messages";
import {authService} from "../../../../../client/connection/Services";
import {collapseIframe, collapseIframeAndExpandWallet} from "../../../../widget/misc/WidgetUtils";
import {MerchantButton} from "../../../../common/MerchantButton";
import {PaymentSucceededIcon} from "../../../../SVGElements";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";
import {Perk} from "./components/CoverageDescriptionElements";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {subscribePlanController} from "../../../inline-subscription/SubscribePlanController";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {MessageElement} from "../../../../widget/ui/MessageElement";


export class SubscribeThankYouPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    title = {
        textAlign: iFrameMerchantService.isMerchant(TNR_ALIAS) ? "left" : "center",
    };

    @styleRule
    icon = {
        textAlign: "center",
    };

    @styleRule
    message = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(SubscribeThankYouPanelStyle)
export class SubscribeThankYouPanel extends BasePanelPage {
    getGuidelines() {
        return iFrameMerchantService.isMerchant(TNR_ALIAS) ? [] : [
            <Perk text={Messages.subscribeThankYouGuideline1}/>,
            <Perk text={Messages.subscribeThankYouGuideline2}/>,
        ]
    }

    render() {
        const {styleSheet} = this;
        const offer = subscribePlanController.selectedOffer;
        let textElements;

        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            textElements = [
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <MessageElement className={styleSheet.message} message={Messages.subscribeThankYouText(offer.coverage.name)}/>,
                <div className={styleSheet.message}>{Messages.tnrSubscribeSuccess}</div>,
                <MessageElement className={styleSheet.message}
                                message={Messages.subscribeAndEditSuccess(iFrameMerchantService.getMerchant().getName())} />
            ];
        } else {
            textElements = [
                <PaymentSucceededIcon className={styleSheet.icon}/>,
                <div testId="subscribeModalThankYouTitle" className={styleSheet.title}>
                    {Messages.subscribeThankYouTitle}
                </div>,
                <div className={styleSheet.message}>{Messages.subscribeThankYouText(offer.coverage.name)}</div>,
            ]
        }

        return [
            textElements,
            this.getGuidelines(),
            <MerchantButton onClick={collapseIframe} className={styleSheet.button}>
                {Messages.ok}
            </MerchantButton>,
            iFrameMerchantService.isMerchant(TNR_ALIAS) ? null :
                <div className={styleSheet.center}>
                    <div className={styleSheet.secondaryButton} onClick={collapseIframeAndExpandWallet}>
                        {Messages.manageMyAccount}
                    </div>
                </div>
        ];
    }

    onMount() {
        super.onMount();

        authService.onAuthenticationChange(() => {
            if (!authService.isAuthenticated()) {
                collapseIframe();
            }
        });
    }
}
